import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedin,
  FaInstagram,
  FaXTwitter,
  FaYoutube,
  FaPinterest,
} from "react-icons/fa6";
import ServiceData from "../../data/service/ServiceMain.json";
import { slugify } from "../../utils";
import axios from "axios";
import API_URL from "./../../common/config";

import Swal from "sweetalert2"; // Import SweetAlert2
import ElegantPopup1 from "../Popup";

const getServiceData = ServiceData;

const FooterOne = ({ parentClass }) => {
  const [email, setEmail] = useState("");
  const [showPopUP, setShowPopUp] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${API_URL}/api/email/subscribe`,
        { email }, // Data payload
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      // Success case
      if (response.status === 201) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
          confirmButtonColor: "#3085d6",
          timer: 2000, // Auto-close after 2 seconds
          timerProgressBar: true,
        }).then(() => {
          setEmail("");
          setShowPopUp(true);
        });
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage =
        error.response?.data?.message || "Subscription failed";

      // Error case with custom icon
      Swal.fire({
        icon: error.response?.status === 409 ? "info" : "error", // 'info' for already subscribed, 'error' for other errors
        title: error.response?.status === 409 ? "Already Subscribed" : "Error",
        text: errorMessage,
        confirmButtonColor: "#6600CC",
      });
    }
  };

  // Rest of your component remains the same...
  return (
    <footer className={`footer-area ${parentClass}`}>
      <div className="container">
        <div className="footer-top">
          <div className="footer-social-link">
            <ul className="list-unstyled social-links">
              <li>
                <a
                  href="https://www.facebook.com/CLIFAINY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a
                  href="https://x.com/ClifAINY"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaXTwitter />
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/clifai/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin />
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/clifainy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </li>
              {/* <li>
                <a
                  href="https://www.instagram.com/clifainy/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <FaYoutube />
                </a>
              </li> */}
              <li>
                <a
                  href="https://www.pinterest.com/connectclifai/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaPinterest />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-main">
          <div className="row">
            <div className="col-xl-6 col-lg-5">
              <div className="footer-widget border-end">
                <div className="footer-newsletter">
                  <h2 className="title">Subscribe for Exclusive Updates!</h2>
                  <p>
                    Stay updated with the latest opportunities, career tips, and
                    more — subscribe to our newsletter today.
                  </p>
                  <form onSubmit={handleSubmit}>
                    <div className="input-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                      <button
                        className="subscribe btn btn-primary try-free-btn"
                        type="submit"
                      >
                        Subscribe
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-7">
              <div className="row">
                <div className="col-sm-6">
                  <div className="footer-widget">
                    <h6 className="widget-title">Features</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        {getServiceData.slice(0, 6).map((data, index) => (
                          <li key={index}>
                            <Link
                              to={
                                process.env.PUBLIC_URL +
                                `/${slugify(data.path)}`
                              }
                            >
                              {data.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-sm-3">
                  <div className="footer-widget">
                    <h6 className="widget-title">Support</h6>
                    <div className="footer-menu-link">
                      <ul className="list-unstyled">
                        <li>
                          <Link to={process.env.PUBLIC_URL + "/contact"}>
                            Contact
                          </Link>
                        </li>
                        <li>
                          {" "}
                          <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>
                            Privacy Policy
                          </Link>
                        </li>
                        <li>
                          <Link to={process.env.PUBLIC_URL + "/terms-use"}>
                            Terms of Use
                          </Link>
                        </li>
                        <li>
                          <Link to={process.env.PUBLIC_URL + "/feedback"}>
                            Feedback
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="row">
            <div className="col-md-6">
              <div className="footer-copyright">
                <span className="copyright-text">
                  © {new Date().getFullYear()}. All rights reserved by CLIF AI
                  Inc.
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <div className="footer-bottom-link">
                <ul className="list-unstyled">
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={process.env.PUBLIC_URL + "/terms-use"}>
                      Terms of Use
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopUP && (
        <div className="popup-overlay">
          <ElegantPopup1
            handlePopUpClose={() => {
              setShowPopUp(false);
            }}
            message={`Thank you for subscribing to CLIF AI :)`}
          />
        </div>
      )}
    </footer>
  );
};

export default FooterOne;
